<template>
    <div class="w-full">
        <canvas ref="chartCanvas"></canvas>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, onUnmounted } from 'vue';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'vue-chartjs';

// Đăng ký các components cần thiết
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const props = defineProps({
    chartData: {
        type: Object,
        required: true
    }
});

const chartCanvas = ref(null);
let chartInstance = null;

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                callback: function(value) {
                    return new Intl.NumberFormat('vi-VN', {
                        style: 'currency',
                        currency: 'VND',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }).format(value);
                }
            }
        }
    },
    plugins: {
        title: {
            display: true,
            text: 'Dòng Tiền Vào/Ra Theo Tháng',
            font: {
                size: 16,
                weight: 'bold'
            }
        },
        legend: {
            display: true,
            position: 'top',
        },
        tooltip: {
            callbacks: {
                label: function(context) {
                    const label = context.dataset.label || '';
                    const value = new Intl.NumberFormat('vi-VN', {
                        style: 'currency',
                        currency: 'VND',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }).format(context.parsed.y);
                    return `${label}: ${value}`;
                }
            }
        }
    },
    interaction: {
        mode: 'index',
        intersect: false,
    },
    animation: {
        duration: 1000,
        easing: 'easeInOutQuart'
    }
};

const createChart = () => {
    if (chartInstance) {
        chartInstance.destroy();
    }

    const ctx = chartCanvas.value.getContext('2d');
    chartInstance = new ChartJS(ctx, {
        type: 'bar',
        data: props.chartData,
        options: chartOptions
    });
};

const updateChart = () => {
    if (chartInstance) {
        chartInstance.data = props.chartData;
        chartInstance.update();
    }
};

onMounted(() => {
    createChart();
});

watch(() => props.chartData, () => {
    updateChart();
}, { deep: true });

onUnmounted(() => {
    if (chartInstance) {
        chartInstance.destroy();
    }
});
</script>

<style scoped>
canvas {
    height: 400px !important;
}
</style>